export default {
  API_ERROR: "Pahoittelut, jokin meni pieleen. Yritä uudelleen.",
  FORM_ERROR: "Pahoittelut, mutta sinun on kirjoitettava hieman enemmän jakaaksesi palautteesi kanssamme."
}